import * as Sentry from '@sentry/react';
import { Config } from '@/utils/config';

interface ReactRenderErrorInfo {
  componentStack?: string | null;
}

function compactError(error: unknown) {
  if (!(error instanceof Error) || !error.stack) {
    return error;
  }

  const frames = error.stack.split('\n');
  if (frames.length <= Config.SENTRY.ERROR_STACK_MAX_FRAMES) {
    return error;
  }

  const compacted = new Error(error.message);
  compacted.name = error.name;
  compacted.stack = frames.slice(0, Config.SENTRY.ERROR_STACK_MAX_FRAMES).join('\n');
  return compacted;
}

export function captureReactRenderError(error: unknown, errorInfo?: ReactRenderErrorInfo) {
  const componentStack = errorInfo?.componentStack;
  Sentry.captureException(compactError(error), {
    extra: {
      componentStack:
        componentStack && componentStack.length > Config.SENTRY.COMPONENT_STACK_MAX_LENGTH
          ? `${componentStack.slice(0, Config.SENTRY.COMPONENT_STACK_MAX_LENGTH)}\n…truncated`
          : componentStack,
    },
    tags: { source: 'react-render' },
  });
}
